<template>
	<div class="row">
        <div class="col text-center">
            <img
                    src="https://nscmediacdn.azureedge.net/nsc/calculators/mental-health/mental-health-calculator.png"
                    alt="Mental Health Cost Calculator - National Safety Council"
                    class="img-fluid text-center mb-4"
            />
        </div>
	</div>
	<p>
        <strong>The National Safety Council</strong> has collaborated with
        an independent research institution,
        <strong>NORC at the University of Chicago</strong>, to create a
        tool demonstrating the cost of employee mental health and illness
        for employers. This cost calculator is an authoritative,
        easy-to-use tool providing business leaders with specific
        information about the cost of mental health (including depression,
        anxiety, and general mental distress) in their workplace based on
        the size of employee base, industry, and state.
	</p>
	<p class="mb-5">
        <a class="btn btn-outline-secondary float-right btn-intro introButton" data-target="#intro" data-placement="top"
           data-original-title="The Mental Health Cost Calculator for Employers" @click="showModal('intro')"
        >
            Learn More
        </a>
	</p>
</template>

<script>
import store from "@/store";

export default {
    name: "Header",
    methods: {
        showModal(modal) {
            store.showModal(modal);
        },
        hideModal() {
            store.hideModal();
        }
    }
}
</script>

<style scoped>

</style>